import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { BehaviorSubject } from 'rxjs';
import { CountryService } from '../../../api/services';

@Component({
  selector: 'app-modal-new-flight-company',
  templateUrl: './modal-new-flight-company.component.html',
  styleUrl: './modal-new-flight-company.component.scss'
})
export class ModalNewFlightCompanyComponent {

  autocompleteCountries$ = new BehaviorSubject<string>('');

  frm = new FormGroup({
    name: new FormControl(''),
    code: new FormControl(''),
  });

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ){ 
    if(config.data.company){
      this.frm.get('code')?.setValue(config.data.company.code)
      this.frm.get('name')?.setValue(config.data.company.name)
    }
  }

  ngOnInit(){

  }

  close() {
    this.ref.close();
  }

  save(){
    this.ref.close({frm: this.frm})
  }

}
